<a *ngIf="showSelector$ | async" nz-dropdown class="dropdown" [nzDropdownMenu]="menu" [nzTrigger]="'click'">
	<i-feather class="icon" name="database"></i-feather>
	<span class="d-none d-xl-inline">
		{{ 'misc.project' | translate }}: <span *ngIf="activeProject$ | async as activeProject">{{ activeProject?.projectname }}</span>
	</span>
</a>

<nz-dropdown-menu #menu="nzDropdownMenu">
	<ul nz-menu>
		<li nz-menu-group>
			<span title>{{ 'topBar.projectManagement' | translate }}:</span>
			<ul class="list-unstyled">
				<li nz-menu-item *ngFor="let project of projects$ | async" (click)="changeProject(project)">
					<span>{{ project.projectname }}</span>
				</li>
			</ul>
		</li>
		<li nz-menu-divider *ngIf="showOverview$ | async"></li>
		<li nz-menu-item (click)="showOverview()" *ngIf="showOverview$ | async">
			<a href="javascript: void(0);">
				<i-feather name="database" class="mr-2"></i-feather>
				{{ 'admin.management' | translate }}
			</a>
		</li>

	</ul>
</nz-dropdown-menu>
